<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-6">
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <ViewWSU title="ข้อมูลพรบ."></ViewWSU>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ViewWSU from "./ViewWSU";
export default {
  name: "customerWsuView",
  components: {
    ViewWSU,
  },
};
</script>
<style scoped></style>
